import type { ButtonLinkVariant } from '@kanda-libs/ks-design-library';

export const LEGAL_TEXT = `$company is an Introducer Appointed Representative of Ideal4Finance. Ideal4Finance is a trading style of Ideal Sales Solutions Ltd, Unit 3, The Crossroads Business Centre, Freckleton Street, Kirkham, PR4 2SH, authorised and regulated by the Financial Conduct Authority. Firm Reference Number 703401. VAT Number GB975327880. Registered in England with Companies House - Company Registration Number: 06724294 Registered with the ICO under registration number Z1790314. Ideal4Finance is acting as a credit broker offering finance products from a panel of lenders Credit is subject to status. Representative example: 11.9% APR Representative based on a loan of £5000 repayable over 60 months at an interest rate of 11.9% pa (fixed). Monthly repayment of £109.45. Total amount payable £6567.16.`;

export const COPY_BUTTON_PROPS = {
  id: 'create-job-send-confirmation-copy-link-button',
  icon: 'copy',
  size: 14,
  left: true,
  label: 'Copy Text',
};

export const COPIED_BUTTON_PROPS = {
  id: 'create-job-send-confirmation-copied-link-button',
  icon: 'check',
  variant: 'turquoise' as ButtonLinkVariant,
  size: 14,
  left: true,
  label: 'Text Copied',
};
